@if ((isPublished$ | async) === false) {
  <nav>
    <a [href]="editUrl" mat-stroked-button color="primary">
      <rma-icon glyph="edit" />&nbsp;
      <span>{{ 'action.edit' | transloco }}</span>
    </a>
    <button type="button" (click)="confirmPublish()" mat-raised-button color="primary" mat-raised-button>
      <rma-icon glyph="save" />&nbsp;
      <span>{{ 'marketReports.actions.publish' | transloco }}</span>
    </button>
  </nav>
} @else {
  <nav>
    <a [href]="manageReportsUrl" mat-stroked-button color="primary">
      <rma-icon glyph="chevron_left" />
      <span>{{ 'action.back' | transloco }}</span>
    </a>
    <button type="button" [matMenuTriggerFor]="menu" mat-raised-button color="primary">
      <rma-icon glyph="send" />
      <span>{{ 'marketReports.actions.send-report' | transloco }}</span>
    </button>
  </nav>
}

<ng-template #send>
  <nav>
    <a [href]="manageReportsUrl" mat-stroked-button color="primary">
      <rma-icon glyph="chevron_left" />
      <span>{{ 'action.back' | transloco }}</span>
    </a>
    <button type="button" [matMenuTriggerFor]="menu" mat-raised-button color="primary">
      <rma-icon glyph="send" />
      <span>{{ 'marketReports.actions.send-report' | transloco }}</span>
    </button>
  </nav>
</ng-template>

<mat-menu #menu="matMenu">
  <button type="button" (click)="downloadPdf()" mat-menu-item>
    <span class="flex">
      <rma-icon glyph="download" />
      {{ 'marketReports.actions.download-pdf' | transloco }}
    </span>
  </button>
  <button type="button" (click)="openSendCommsDialog(marketReportCommunicationTypeEnum.email)" mat-menu-item>
    <span class="flex">
      <rma-icon glyph="email" />
      {{ 'marketReports.actions.send-email' | transloco }}
    </span>
  </button>
  @if (showSmsMenuItem$ | async) {
    <button type="button" (click)="openSendCommsDialog(marketReportCommunicationTypeEnum.sms)" mat-menu-item>
      <span class="flex">
        <rma-icon glyph="phone" />
        {{ 'marketReports.actions.send-sms' | transloco }}
      </span>
    </button>
  }
  <button type="button" (click)="downloadQrCode()" mat-menu-item>
    <span class="flex">
      <rma-icon glyph="qr_code_2" />
      {{ 'action.generate-qr-code' | transloco }}
    </span>
  </button>
</mat-menu>
